import { CircularProgress, Divider } from '@material-ui/core';

import { createPortal } from 'react-dom';
import {
  Container,
  ActionMenu,
  StyledIcon,
  StyledActionButton,
  DeselectButton,
  NumberWrapper,
  SelectedWrapper,
  StyledTooltip
} from './style';
import { TextColor } from '../../enums';

export interface BulkMenuAction {
  color?: string;
  icon?: JSX.Element;
  label: string;
  tooltip?: string;
  disabled?: boolean;
  loading?: boolean;
  onClick: () => void;
}

interface BulkMenuProps {
  totalSelected: number;
  actions: BulkMenuAction[];
  onCancel: () => void;
  showLabels?: boolean;
  portalTarget?: HTMLElement | null;
}

export const SBulkMenu = ({
  totalSelected,
  actions,
  onCancel,
  showLabels = false,
  portalTarget
}: BulkMenuProps) => {
  const content = (
    <Container>
      <SelectedWrapper noWrap fontColor={TextColor.DarkGrey}>
        <NumberWrapper>{totalSelected}</NumberWrapper>
        Selected
      </SelectedWrapper>

      <Divider flexItem orientation="vertical" />

      <ActionMenu>
        {actions?.map(
          ({ color, icon, label, tooltip, disabled, loading, onClick }) => {
            const isDisabled = disabled || loading;
            const renderedIcon = loading ? (
              <CircularProgress
                size={16}
                style={{ color: color || undefined }}
              />
            ) : (
              icon
            );

            return showLabels ? (
              <StyledTooltip
                title={tooltip || ''}
                key={label}
                placement="top"
                arrow
                disableHoverListener={!tooltip}>
                <span>
                  <StyledActionButton
                    disabled={isDisabled}
                    onClick={e => {
                      e.preventDefault();
                      e.stopPropagation();
                      onClick();
                    }}
                    startIcon={renderedIcon}
                    style={{ borderColor: color, color: color || undefined }}>
                    {label}
                  </StyledActionButton>
                </span>
              </StyledTooltip>
            ) : (
              <StyledTooltip title={label} key={label} arrow placement="top">
                <StyledIcon
                  onClick={e => {
                    if (isDisabled) return;
                    e.preventDefault();
                    e.stopPropagation();
                    onClick();
                  }}
                  style={{
                    borderColor: color,
                    opacity: isDisabled ? 0.5 : 1,
                    pointerEvents: isDisabled ? 'none' : 'auto'
                  }}>
                  {renderedIcon}
                </StyledIcon>
              </StyledTooltip>
            );
          }
        )}
      </ActionMenu>

      <Divider flexItem orientation="vertical" />

      <DeselectButton variant="text" onClick={onCancel} color="primary">
        Cancel
      </DeselectButton>
    </Container>
  );

  const target = portalTarget ?? document.getElementsByTagName('main')[0];
  if (!target) return null;
  return createPortal(content, target);
};
